import { render, staticRenderFns } from "./Bold.vue?vue&type=template&id=30e91676&"
import script from "./Bold.vue?vue&type=script&lang=js&"
export * from "./Bold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports